import onIntersectionObserve from '@/helpers/on_intersection_observe';
import { isMobile } from '@/helpers/mobile_detect';

let comparisonSliderApp = null;

$(document).on('turbolinks:before-cache', () => {
  if (comparisonSliderApp) {
    comparisonSliderApp.unmount();
    comparisonSliderApp = null;
  }
});

$(document).on('turbolinks:load', () => {
  const sliderNode = document.querySelector('.become_a_partner #franchise_comparison_slider');
  if (!sliderNode) { return; }

  onIntersectionObserve(
    sliderNode,
    async node => {
      const { createApp, h } = await import(/* webpackChunkName: "vue" */ 'vue');
      const { default: Component } = await import('@/vue/franchise/comparison_slider');

      const $node = $(node);

      comparisonSliderApp = createApp({
        setup: () => () => h(Component, {
          leftImageUrl: $node.data(`left_image_${isMobile() ? 'mobile' : 'desktop'}_url`),
          rightImageUrl: $node.data(`right_image_${isMobile() ? 'mobile' : 'desktop'}_url`)
        })
      });
      comparisonSliderApp.mount(node);
    }
  );
});
